import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { Route } from '../../config/router'
import { useConsumerLendingEligible, usePaymentTypeAllowInConvergence } from '../../state'
import { PaymentType } from '@afterpay/types'

// This is a temporary measure until we flesh out an AuthProtection component
export const withCLAuth = (Component: React.FC) => (props) => {
  const router = useRouter()
  const isConsumerLendingEligible = useConsumerLendingEligible() ?? false
  const isConsumerLendingAllowInConvergence = usePaymentTypeAllowInConvergence(PaymentType.PCL)

  useEffect(() => {
    // assume that the component in this context is CL related
    if (!isConsumerLendingEligible || !isConsumerLendingAllowInConvergence) {
      router.replace(Route.SUMMARY)
    }
  }, [])

  return <Component {...props} />
}
